<template>
  <div>
    <v-container grid-list-md fluid>
      <v-layout wrap>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">CN detail</span>
                </v-toolbar-title>
              </v-toolbar>
              <v-layout wrap>
                <v-flex xs4>
                  <v-card color="white">
                    <v-card-title class="pb-0">
                      <div class="subheading">Date :</div>
                      <h3>{{cn_created_date}}</h3>
                    </v-card-title>
                    <v-card-title class="pb-0">
                      <div class="subheading">Customer :</div>
                      <h3>{{customer_name}}</h3>
                    </v-card-title>
                    <v-card-title class="pb-0">
                      <div class="subheading">Remark/Reason :</div>
                      <h3>{{remark}}</h3>
                    </v-card-title>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-btn
                    color="primary"
                    :loading="saving"
                    :disabled="saving"
                    @click="dialog_change_detail=true"
                  >Change</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">Add CN item</span>
                  <span style="color:#0cabc2">(Total: RM{{parseFloat(total_amount).toFixed(2)}})</span>
                </v-toolbar-title>
              </v-toolbar>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:keyup.enter="vege_change_clear_field(),VegeNext(),checkingProudctType()"
                    v-on:change="vege_change_clear_field(),VegeNext(),checkingProudctType()"
                    
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs1 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    v-on:keyup.enter="LocationNext()"
                    item-text="name"
                    item-value="name"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.01)"
                    type="number"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs2>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    ref="qty"
                    type="number"
                    label="Qty"
                    box
                  ></v-text-field>
                </v-flex>

                <!-- Type Price -->
                <v-flex xs1>
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                    v-on:change="price = Math.max(Math.min(price, 9999999), 0)"
                    ref="price"
                    type="number"
                    label="Price"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn color="primary" @click="additemToDO()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="stock"
                    :search="search"
                    disable-initial-sort
                    :rows-per-page-items="[100, 150, 200, 250]"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td class="text-xs-right">{{ props.item.product_name }}</td>
                        <td class="text-xs-right">{{ props.item.grade }}</td>
                        <td class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.weight }}{{ props.item.product_type}}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td class="text-xs-right">{{ props.item.total_weight }}{{ props.item.product_type}}</td>

                        <td class="text-xs-right">RM{{ props.item.price }}</td>

                        <td class="text-xs-right">RM{{props.item.amount }}</td>

                        <td class="justify-end layout px-5">
                          <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
                          <v-icon
                            medium
                            color="error"
                            @click="deleteItem(props.item.id)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialog_edit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit item</span>
        </v-card-title>

        <v-card-text>
          <edit_dialog ref="edit" @update="getDOStock(cn_id)"></edit_dialog>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_change_detail" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Change</span>
        </v-card-title>
        <v-card-text>
          <v-flex xs11>
            <v-menu
              lazy
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                label="Date"
                v-model="cn_created_date"
                persistent-hint
                outline
                readonly
              ></v-text-field>

              <v-date-picker v-model="cn_created_date" no-title actions></v-date-picker>
            </v-menu>
          </v-flex>
          <!-- customer selection  -->
          <v-flex xs11>
            <v-autocomplete
              v-model="customer_id"
              :items="customerList"
              item-text="name"
              item-value="id"
              label="Customer"
              persistent-hint
              small-chips
              outline
            ></v-autocomplete>
          </v-flex>

          <v-flex xs11>
            <v-textarea outline auto-grow height="25px" v-model="remark" label="Remark/Reason"></v-textarea>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="updateDoDetail()">Save</v-btn>
          <v-btn flat @click="dialog_change_detail=false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="2500">
      {{response}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import edit_dialog from "@/components/large_component/edit_dialog";
import moment from "moment";
import { debounce } from "lodash";

export default {
  components: {
    edit_dialog
  },
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    saving: false,
    errors: "",
    baseUrl: baseUrl,
    dialog_edit: false,
    headers: [
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "right", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Location", align: "right", value: "location" },
      { text: "Weight", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "Total kg/box", align: "right", value: "total_weight" },

      { text: "Price", align: "right", value: "price" },
      { text: "Amount", align: "right", value: "amount" },

      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    stock: [],
    selected_farmer: "",
    selected_po_id: "",
    snackbar_response: false,
    response: "",
    type_need_weight: false,
    //logic control
    product_type_need_weight: true,
    setting_grade: true,
    setting_location: true,
    setting_price: true,
    limitDay: "",

    date: moment().format("YYYY-MM-DD"),
    do_date: "",
    cn_id: "",
    product: "",
    weight: "",
    quantity: "",
    price: "",
    limitDay: "",
    grade: "",
    location: "",

    total_amount: "",

    customer_name: "",
    customer_id: "",
    cn_created_date: "",
    remark: "",

    dialog_change_detail: false,
    customerList: [],

    productList: [],
    gradeList: [],
    locationList: [],
    // dialog snackbar date_box
    setting_dialog: false,
    date_box: false,
    vege_adding_loading_dialog: false,
    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response_detail: "",
    vege_adding_loading_value: ""
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    },
    "props.item.price"(np) {
      console.log(np);
    }
  },
  mounted() {
    this.intervalFetch();
  },

  created() {
    this.getProduct();
    this.getCustomer();

    this.getGrade();
    this.getLocation();
    this.debouncedGetAnswer = _.debounce(this.getAnswer, 500);
  },

  methods: {
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
            console.log("Customer List hahahahaa");
            console.log(response.data.data);
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getDOStock(cn_id) {
      this.total_amount = 0;
      //   this.dialog_edit = false;
      this.cn_id = cn_id;

      this.getDODetail(cn_id);
      const params = new URLSearchParams();

      params.append("getCNDetail", "getCNDetail");
      params.append("cn_id", cn_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.stock = response.data.data;

            for (var i = 0; i < this.stock.length; i++) {
              var row_amount =
                this.stock[i].weight *
                this.stock[i].price *
                this.stock[i].quantity;

              var total_weight = this.stock[i].weight * this.stock[i].quantity;

              this.$set(this.stock[i], "total_weight", total_weight);

              this.$set(
                this.stock[i],
                "amount",
                parseFloat(row_amount).toFixed(2)
              );

              this.total_amount += row_amount;
            }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getDODetail(cn_id) {
      const params = new URLSearchParams();

      params.append("readCN", "readCN");
      params.append("cn_id", cn_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
        data: params
      })
        .then(response => {
          console.log("whyuuuuuuu");
          console.log(response.data.data);

          if (response.data.error == false) {
            var do_detail = response.data.data;
            this.customer_name = do_detail[0].customer_name;
            this.customer_id = parseFloat(do_detail[0].customer_id);
            this.cn_created_date = do_detail[0].created_at;
            this.remark = do_detail[0].remark;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    updateDoDetail() {
      const params = new URLSearchParams();

      params.append("updateCN", "updateCN");
      params.append("cn_id", this.cn_id);
      params.append("customer_id", this.customer_id);
      params.append("remark", this.remark);
      params.append("created_at", this.cn_created_date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.getDOStock(this.cn_id);
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.dialog_change_detail = false;
              this.$emit("update", "someValue");

          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    deleteItem(id) {
      const params = new URLSearchParams();
      params.append("deleteCNItem", "deleteCNItem");
      params.append("cn_item_id", id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
        data: params
      })
        .then(response => {
            console.log(response);
          if (response.data.error == false) {
            this.getDOStock(this.cn_id);
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    additemToDO() {
      //checking whether data filled
      if (this.weight != null && this.quantity != null) {
        if (this.grade == "") {
          this.grade = "unknown";
        }
        if (this.location == "") {
          this.location = "unknown";
        }
        if (this.price == "") {
          this.price = "0";
        }
        const params = new URLSearchParams();
        params.append("createCNItem", "createCNItem");
        params.append("customer_id", this.customer_id);

        params.append("cn_id", this.cn_id);
        params.append("product_id", this.product.id);
        params.append("type", this.product.type);
        params.append("weight", this.weight);
        params.append("grade", this.grade);
        params.append("location", this.location);
        params.append("quantity", this.quantity);
        params.append("price", this.price);



        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
          data: params
        })
          .then(response => {
            if (response.data.error == false) {
              //set response to selected data

              this.product = "";
              this.vege_change_clear_field();
              this.getDOStock(this.cn_id);
            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
          });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.vege_change_clear_field();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.vege_change_clear_field();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },

    checkingProudctType() {
      if (this.product.type == "box" || this.product.type == "pcs"|| this.product.type == "pkt"|| this.product.type == "bag" ) {
        this.product_type_need_weight = false;
        this.weight = "1";
      } else {
        this.product_type_need_weight = true;
        this.weight = "";
      }
    },
    VegeNext_item() {
      if (this.setting_grade == true) {
        this.$refs.grade.focus();
        this.$refs.grade.activateMenu();
      } else if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.product.type == "box") {
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    VegeNext() {
      var self = this;
      setTimeout(function() {
        self.VegeNext_item();
      }, 200);
    },

    GradeNext() {
      if (this.setting_location == true) {
        console.log("hahaaa");
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.product.type == "box") {
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    LocationNext() {
      if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pcs"|| this.product.type == "pkt") {
        this.$refs.qty.focus();
      }
      {
        this.$refs.weight.focus();
      }
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      if (this.setting_price == true) {
        this.$refs.price.focus();
      } else {
        this.additemToDO();
      }
    },
    PriceNext() {
      this.additemToDO();
      this.$refs.product.focus();
    },
    vege_change_clear_field() {
      this.location = "";
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
    },

    editItem(id) {
      this.dialog_edit = true;
      this.$refs.edit.fetch_item(id);
      
    },
    intervalFetch: function() {
      setInterval(() => {
        this.limitDay = localStorage.stocked_day_limit;
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;
        this.setting_price = localStorage.setting_price;
        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }

        if (this.setting_price == "true") {
          this.setting_price = true;
        } else {
          this.setting_price = false;
        }
      }, 500);
    }
  }
};
</script>

